import type { errorsObjectType, TokenType } from '@/types/common';
export const defaultToken: TokenType = '';

export const errorsConst: errorsObjectType = Object.freeze({
  non_field_errors: [],
});

const mockCalculation = {
  created_at: '2024-12-25T06:52:50.749341',
  is_saved: true,
  pack_rule_id: 28,
  id: 153,
  results: [
    {
      name: 'TE_0',
      size: {
        width: 2000,
        height: 2500,
        depth: 1500,
        weight: 500,
      },
      items: [
        {
          article: '61017334',
          typeof: 'cube',
          color: '#BDC3C7',
          size: {
            width: 209,
            height: 259,
            depth: 373,
            weight: 10,
          },
          position: {
            x: 538,
            y: 0,
            z: 0,
          },
        },
        {
          article: '61014428',
          typeof: 'cube',
          color: '#95A5A6',
          size: {
            width: 248,
            height: 210,
            depth: 388,
            weight: 8,
          },
          position: {
            x: 290,
            y: 210,
            z: 0,
          },
        },
        {
          article: '61014428',
          typeof: 'cube',
          color: '#95A5A6',
          size: {
            width: 248,
            height: 210,
            depth: 388,
            weight: 8,
          },
          position: {
            x: 290,
            y: 0,
            z: 0,
          },
        },
        {
          article: '61000433',
          typeof: 'cube',
          color: '#E74C3C',
          size: {
            width: 290,
            height: 255,
            depth: 315,
            weight: 3,
          },
          position: {
            x: 0,
            y: 0,
            z: 0,
          },
        },
        {
          article: '61012198',
          typeof: 'cube',
          color: '#F1C40F',
          size: {
            width: 248,
            height: 164,
            depth: 388,
            weight: 6,
          },
          position: {
            x: 747,
            y: 0,
            z: 0,
          },
        },
      ],
    },
    {
      name: 'TE_1',
      size: {
        width: 2000,
        height: 2500,
        depth: 1500,
        weight: 500,
      },
      items: [
        {
          article: '61017334',
          typeof: 'cube',
          color: '#BDC3C7',
          size: {
            width: 209,
            height: 259,
            depth: 373,
            weight: 10,
          },
          position: {
            x: 538,
            y: 0,
            z: 0,
          },
        },
        {
          article: '61014428',
          typeof: 'cube',
          color: '#95A5A6',
          size: {
            width: 248,
            height: 210,
            depth: 388,
            weight: 8,
          },
          position: {
            x: 290,
            y: 210,
            z: 0,
          },
        },
        {
          article: '61014428',
          typeof: 'cube',
          color: '#95A5A6',
          size: {
            width: 248,
            height: 210,
            depth: 388,
            weight: 8,
          },
          position: {
            x: 290,
            y: 0,
            z: 0,
          },
        },
        {
          article: '61000433',
          typeof: 'cube',
          color: '#E74C3C',
          size: {
            width: 290,
            height: 255,
            depth: 315,
            weight: 3,
          },
          position: {
            x: 0,
            y: 0,
            z: 0,
          },
        },
        {
          article: '61012198',
          typeof: 'cube',
          color: '#F1C40F',
          size: {
            width: 248,
            height: 164,
            depth: 388,
            weight: 6,
          },
          position: {
            x: 747,
            y: 0,
            z: 0,
          },
        },
      ],
    },
  ],
};
